class AuthPopup extends HTMLElement {
  constructor() {
    super();
    this._onKeydown = this._onKeydown.bind(this);
    this._lastFocus = null;

    // bind để remove listener nếu cần
    this._onDocClick = this._onDocClick.bind(this);
  }

  connectedCallback() {
    this.dialog = this.querySelector(".auth-popup__dialog");
    this.tabs = Array.from(this.querySelectorAll("[data-auth-tab]"));
    this.panels = Array.from(this.querySelectorAll("[data-auth-panel]"));

    // Close handlers + tab switch + recover/back
    this.addEventListener("click", (e) => {
      if (e.target.closest("[data-auth-close]")) this.close();
      if (e.target.closest("[data-auth-back]")) this.show("login");

      const showBtn = e.target.closest("[data-auth-show]");
      if (showBtn) this.show(showBtn.dataset.authShow);

      const tabBtn = e.target.closest("[data-auth-tab]");
      if (tabBtn) this.show(tabBtn.dataset.authTab);

      // ✅ toggle password (chỉ bắt click trong popup)
      const toggleBtn = e.target.closest("[data-toggle-password]");
      if (toggleBtn) this._togglePassword(toggleBtn);
    });

    // Triggers outside
    document.addEventListener("click", this._onDocClick);
  }

  disconnectedCallback() {
    document.removeEventListener("click", this._onDocClick);
    document.removeEventListener("keydown", this._onKeydown);
  }

  _onDocClick(e) {
    const openBtn = e.target.closest("[data-auth-open]");
    if (!openBtn) return;
    e.preventDefault();
    this.open(openBtn.dataset.authOpen || "login");
  }

  _togglePassword(btn) {
    const fieldset = btn.closest(".password-wrapper");
    const input = fieldset?.querySelector("input.password-field");
    if (!input) return;

    const isPassword = input.type === "password";
    input.type = isPassword ? "text" : "password";
    btn.classList.toggle("is-active", isPassword);
  }

  open(panel = "login") {
    this._lastFocus = document.activeElement;

    this.removeAttribute("hidden");
    this.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";

    this.show(panel);
    document.addEventListener("keydown", this._onKeydown);

    requestAnimationFrame(() => {
      this.dialog?.focus();
      const active = this.querySelector(".auth-popup__panel.is-active");
      active?.querySelector("input, button, [href], select, textarea, [tabindex]:not([tabindex='-1'])")?.focus();
    });
  }

  close() {
    this.setAttribute("hidden", "");
    this.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
    document.removeEventListener("keydown", this._onKeydown);

    this._lastFocus?.focus?.();
  }

  show(panel) {
    this.panels.forEach((p) => p.classList.toggle("is-active", p.dataset.authPanel === panel));

    this.tabs.forEach((t) => {
      const isActive = t.dataset.authTab === panel;
      t.classList.toggle("is-active", isActive);
      t.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    const title = this.querySelector("#AuthPopupTitle");
    if (!title) return;

    const map = {
      login: title.dataset.titleLogin,
      register: title.dataset.titleRegister,
      recover: title.dataset.titleRecover
    };

    title.textContent = map[panel] || title.dataset.titleLogin;
  }

  _onKeydown(e) {
    if (e.key === "Escape") this.close();
  }
}

customElements.define("auth-popup", AuthPopup);